import { Link } from "react-router-dom";
import './index.css'

function Notfound(){
    return(
        <div className="notfound">
            <h1>Not Found</h1>
            <p>página não encontrada!</p>
            <Link to='/'>Voltar para lista de filmes</Link>
        </div>
    )
}

export default Notfound;